export default __webpack_public_path__ + "static/Saira-ExtraBold-c4c8cd4dda080300d0b45abdbaaedc75.woff2";